import React from 'react';

const GranteeViewNextYearTab = props => (
  <div>This page is not available at this time.</div>
);

export default GranteeViewNextYearTab;
